import {
  SlTag
} from "./chunk.6R4LM7O6.js";

// src/components/tag/tag.ts
var tag_default = SlTag;
SlTag.define("sl-tag");

export {
  tag_default
};
